import React, { useState, useRef, useContext, useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import * as auth from '../redux/AuthRedux'
import { login2Fa } from '../redux/AuthCRUD'
import { AuthContext } from '../context/AuthContext'
import { useHistory } from 'react-router-dom'
import { KEY } from '../../../shared/constants/shared-contants'
import { TwoFactorMethod } from '../../../../app/modules/common/enum/two-factor-method'
import TwoFactorInput from "./TwoFactorInput";

interface IProps {
  cancelHandler: () => void
}

const Login2Fa: React.FC<IProps> = ({ cancelHandler }) => {
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const [codeDigits, setCodeDigits] = useState(Array(6).fill(''));
  const inputRefs = useRef<Array<HTMLInputElement | null>>([]);
  const [status, setStatus] = useState('');
  const history = useHistory();
  const { email, twoFactorMethod } = useContext(AuthContext);

  useEffect(() => {
    if (!email) {
      history.push('/auth/login');
    }
  }, [history, email])

  const handleSubmit = useCallback(async (code: string) => {
    setLoading(true);
    setTimeout(() => {
      login2Fa(email, code)
        .then(({ data: { token, twoFactorEnabled } }) => {
          setLoading(false);
          dispatch(auth.actions.login(token));
        })
        .catch((err) => {
          setLoading(false);
          setStatus('The verification code is incorrect');
        });
    }, 1000);
  }, [email]);

  return (
    <>
      {status ? (
        <div className='mb-lg-15 alert alert-warning'>
          <div className='alert-text font-weight-bold'>{status}</div>
        </div>
      ) : (
        <></>
      )}
      <div className='text-center mb-10'>
        <h1 className='text-dark mb-3'>Security Verification</h1>
        <h6 className='mb-3'>
          {twoFactorMethod === TwoFactorMethod.AuthenticatorApp ? 'Authenticator' : 'Email'}
        </h6>
        <span>
          {twoFactorMethod === TwoFactorMethod.AuthenticatorApp
            ? 'Please enter the generated code from your Authenticator Application'
            : 'Please enter the OTP sent to your email'}
        </span>
      </div>
      <TwoFactorInput onComplete={handleSubmit} />
    </>
  )
}

export { Login2Fa }
